import { CUSTOM_ELEMENTS_SCHEMA, Component, effect, input, output, signal } from '@angular/core';
import { CalendarData, Calendar_onValueChangeEvent } from '@inmoment/the-kitchen';

import { AppSharedModule } from 'app/app-shared.module';
import {
  DATE_TIME_WITHOUT_TIMEZONE_FORMAT,
  Filter,
  FilterService,
} from 'app/modules/collection/services/filter.service';
import { TimezoneService } from 'app/services/timezone.service';

@Component({
  selector: 'app-filter-date-calendar',
  imports: [AppSharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './filter-date-calendar.component.html',
  styleUrls: ['./filter-date-calendar.component.scss'],
})
export class FilterDateCalendarComponent {
  readonly field = input<string>();
  readonly filter = input<Filter>();
  readonly placeholder = input<string>('MM/DD/YYYY');
  readonly filtersChange = output();

  displayValueSignal = signal<{ fixedRange: CalendarData; relativeRange: string }>(undefined, {
    debugName: 'displayValue_setter',
  });

  calendarMode = 'fixed';

  constructor(
    private timezoneService: TimezoneService,
    private filterService: FilterService
  ) {
    effect(() => {
      this.displayValueSignal.set(this.fromFilter(this.filter()));
    });
  }

  fromFilter = (filter: Filter) => {
    const ret = {
      fixedRange: {
        initialDateRange: {
          first: null,
          last: null,
        },
        preselectedCalendarListOptions: this.filterService.generateRelativeRangeOptions(),
      },
      relativeRange: null,
    };

    if (!filter.value) {
      this.calendarMode = 'fixed';

      return ret;
    }

    const range = filter.value.split('/');
    ret.relativeRange = filter.key;
    this.calendarMode = 'relative';

    if (filter.key === 'daterange') {
      ret.relativeRange = null;
      ret.fixedRange.initialDateRange.first = new Date(range[1]);
      ret.fixedRange.initialDateRange.last = new Date(range[2]);
      this.calendarMode = 'fixed';
    }

    return ret;
  };

  toFilter = (value: Calendar_onValueChangeEvent): any => {
    const firstDate = this.timezoneService
      .padToStart(value.dates.first)
      .format(DATE_TIME_WITHOUT_TIMEZONE_FORMAT);
    const lastDate = this.timezoneService
      .padToEnd(value.dates.last)
      .format(DATE_TIME_WITHOUT_TIMEZONE_FORMAT);
    let filterValue = `daterange/${firstDate}/${lastDate}`;
    let filterKey = 'daterange';

    if (value.optionId) {
      filterValue = value.optionId;
      filterKey = value.optionId;
    }

    return {
      analyticItem: this.field(),
      value: filterValue,
      key: filterKey,
    };
  };

  onFilterValueSet($event) {
    const calData: Calendar_onValueChangeEvent = $event.detail;
    this.displayValueSignal.set({
      fixedRange: {
        initialDateRange: calData.dates,
        preselectedCalendarListOptions:
          this.displayValueSignal().fixedRange.preselectedCalendarListOptions,
      },
      relativeRange: calData.optionId,
    });

    this.filtersChange.emit(this.toFilter(calData));
  }
}
